"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const videoStyles_1 = require("../../styling/videoStyles");
/**
 * styling
 */
const styles = {
    pillWrapper: {
        width: 120,
        position: "relative",
        borderTop: "1px solid #d1d5db",
        display: "flex",
        alignItems: "center",
        paddingTop: 5,
        paddingRight: 10,
        paddingLeft: 10,
        paddingBottom: 5,
        background: "#ffffff",
    },
    pill: {
        marginLeft: 10,
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: 40,
        height: 20,
        borderRadius: 20,
        background: "#e5e7eb",
        border: "solid 1px #d1d5db",
        transition: "all 0.3s ease-in-out",
    },
    pillBall: {
        position: "absolute",
        height: 14,
        width: 14,
        left: 3,
        borderRadius: 100,
        background: "#ffffff",
        transition: "all 0.3s ease-in-out",
        transform: "translate(0px, 0px)",
    },
    label: {
        cursor: "default",
        fontSize: 12,
        color: "#374151",
        fontFamily: "Lato, Arial, sans-serif",
    },
    activePill: {
        background: "#175cd3",
        border: "solid 1px #d1d5db",
    },
    activePillBall: {
        height: 14,
        width: 14,
        borderColor: "#111111",
        transform: "translate(12px, 0px)",
        background: "#ffffff",
    },
    disabled: {
        height: "100%",
        width: "100%",
        zIndex: 999,
        background: "rgba(81, 81, 81, 0.5)",
        cursor: "not-allowed",
        position: "absolute",
    },
};
function PillToggle({ disabled, classes = {}, className = "", label, handleClick, disabledOff, disabledOn, isActive, ...rest }) {
    /**
     * Local state to set the pill toggle to active/inactive.
     */
    const [active, setActive] = (0, react_1.useState)(isActive);
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: styles }, "radio");
    /**
     *  Watching the setActive prop so our parent element has the same state as the toggle.
     */
    (0, react_1.useEffect)(() => {
        if (isActive !== undefined) {
            setActive(isActive);
        }
    }, [isActive]);
    return (react_1.default.createElement("div", { className: `${mergedClasses.pillWrapper} ${className}`, style: {
            cursor: disabledOn || disabledOff ? "not-allowed" : "pointer",
        } },
        disabled && react_1.default.createElement("div", { className: mergedClasses.disabled }),
        react_1.default.createElement("div", { className: `${mergedClasses.label} ${className}` },
            " ",
            label,
            " "),
        react_1.default.createElement("div", { role: "button", tabIndex: !disabled ? 0 : -1, onKeyDown: (e) => e.key === "Enter" && !disabledOn && !disabledOff && (setActive(!active), handleClick), onClick: () => {
                if (!disabledOn && !disabledOff) {
                    setActive(!active);
                    handleClick === null || handleClick === void 0 ? void 0 : handleClick();
                }
            }, className: `${mergedClasses.pill} ${className} ${active && mergedClasses.activePill}` },
            react_1.default.createElement("div", { className: `${mergedClasses.pillBall} ${className} ${active && mergedClasses.activePillBall}` }))));
}
exports.default = PillToggle;
//# sourceMappingURL=PillToggle.js.map